module.exports = __webpack_public_path__ + "img/VERIFICA_CEDULASWEB.5f084297.svg";